import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { DefaultThemesV2 } from '../../stylesheets/themes/SCDefaultThemes.style';
import { NavBarItem, NavBarIcon } from './TopNavBar.style';
import { useInteractionContext } from '@components/ElementAnalytics/InteractionContext';
import LEActionRequired from '@components/Component/LearnosityExams/contexts/LEActionRequired';
import ActionRequiredWrapper from '@contexts/ActionRequired/ActionRequiredWrapper';

const NavBarItemComponent = ({
  url,
  icon,
  dataTip,
  label,
  transform = true,
  hasSection = true,
  isExternal = false,
  isAdmin = false,
  courseId,
  sectionId,
  courseList,
  pathname,
  redirectPage,
  redirectExternal,
  actionRequiredKey
}) => {
  const { getTestId } = useInteractionContext()
  let transformUrl = url;

  if (transform && !isAdmin) {
    if (courseId !== null) {
      transformUrl += `${courseId}`;

      if (sectionId && hasSection) {
        transformUrl += `/section/${sectionId}`;
      }
    } else {
      const firstCourseId = _get(courseList, '[0].id', 1);

      transformUrl += `${firstCourseId}`;
    }
  }

  if (dataTip === 'My Library') {
    transformUrl = `${transformUrl}/library`;
  }

  const isActive = pathname.startsWith(url);

  if (isActive) {
    transformUrl = '#';
  }

  const renderInnerContent = () => {
    return <>
      {dataTip === 'My Library' ? (
        <NavBarIcon
          src={`/images/${icon}`}
          data-tip={dataTip}
          data-for="tooltip-top-nav-bar"
          className="actionable"
        />
      ) : (
        <span
          className={`${icon} actionable`}
          data-tip={dataTip}
          data-for="tooltip-top-nav-bar"
        />
      )}
      <label
        style={{
          display: 'block',
          color: DefaultThemesV2.colorStyled.ColorPrimary,
          fontSize: '11px',
          cursor: 'pointer',
          margin: '5px',
        }}
      >
        {label}
      </label>
    </>
  }

  const handler = () => {
    if (!isExternal) {
      redirectPage(transformUrl);
    } else {
      redirectExternal(url);
    }
  };

  return (
    <NavBarItem
      onClick={handler}
      isActive={isActive}
      data-testid={getTestId(`navbar-item-${label || dataTip || icon}`)}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handler();
        }
      }}
    >

      <div>
        {!!actionRequiredKey ? <LEActionRequired>
          <ActionRequiredWrapper checkPath={actionRequiredKey}>
            {renderInnerContent()}
          </ActionRequiredWrapper>
        </LEActionRequired> : renderInnerContent()}
      </div>
    </NavBarItem>
  );
};

export default NavBarItemComponent;
